import service from '@/store/services/settings/wards-service';

const state = {
    list: {},
    ward: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, ward) => {
        state.ward = ward;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(ward => {
                commit('SET_RESOURCE', ward);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(ward => {
                commit('SET_RESOURCE', ward);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((ward) => {
                commit('SET_RESOURCE', ward);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((ward) => {
                commit('SET_RESOURCE', ward);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    ward: state => state.ward,
    dropdown: (state) => {
        return state.list.map(ward => ({
            id: ward.id,
        }));
    }
};

const wards = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default wards;
